import { useContext } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";

export const DamageArea = () => {
	const nextPage = "selectDateTime";
	const previousPage = "damageType";

	return (
		<>
			<Header />
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const { data, setData, isTransitioning } = useContext(AppContext);

	const updateDamageArea = (damageArea) => () => {
		setData({ ...data, damageArea });
	};

	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_damage_area">
				<div className="content_title">
					<h2 className="select_damage_area">
						<strong>Indica la zona del daño</strong>
					</h2>
				</div>
				<div className="damage_area_options">
					<div className="damage_area_legend">
						<img
							className="damage_area_default"
							src="resources/img/damage_area.png"
							alt="Selecciona el área dañada"
						/>
						<img
							className={
								data.damageArea === "repair" ? "selected" : ""
							}
							src="resources/img/damage_area_green.png"
							alt="Selecciona el área dañada"
						/>
						<img
							className={
								data.damageArea === "replacement"
									? "selected"
									: ""
							}
							src="resources/img/damage_area_red.png"
							alt="Selecciona el área dañada"
						/>
						<div
							className="check_green_damage_area"
							onPointerDown={updateDamageArea("repair")}
						/>
						<div
							className="check_red_damage_area"
							onPointerDown={updateDamageArea("replacement")}
						/>
					</div>
					<div
						className={
							"green_damage_area kensei_03" +
							(data.damageArea === "repair" ? " selected" : "")
						}
						onPointerDown={updateDamageArea("repair")}
					>
						<div
							className={
								"check_damage_area kensei_03" +
								(data.damageArea === "repair"
									? " selected"
									: "")
							}
						>
							<img
								src="resources/icons/check.svg"
								alt="Seleccionar zona verde"
							/>
						</div>
						<div>
							<h3>Zona verde - Reparación</h3>
							<p>
								Área alejada de los bordes y de la vista
								delantera del conductor
							</p>
						</div>
					</div>
					<div
						className={
							"red_damage_area kensei_03" +
							(data.damageArea === "replacement"
								? " selected"
								: "")
						}
						onPointerDown={updateDamageArea("replacement")}
					>
						<div
							className={
								"check_damage_area kensei_03" +
								(data.damageArea === "replacement"
									? " selected"
									: "")
							}
						>
							<img
								src="resources/icons/check_red.svg"
								alt="Seleccionar zona roja"
							/>
						</div>
						<div>
							<h3>Zona roja - Sustitución</h3>
							<p>
								Franja vertical con respecto al volante o a
								menos de 5 cms del borde de la luna
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
